import script from "./GlobalCustomerService.vue?vue&type=script&lang=ts&setup=true"
export * from "./GlobalCustomerService.vue?vue&type=script&lang=ts&setup=true"

import "./GlobalCustomerService.vue?vue&type=style&index=0&id=3e911c64&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e911c64"]])

export default __exports__